// @ts-nocheck
/**
 * Product Builder — in-box voice recorder for long-text / topic answer fields.
 * Uses pbAudioEngine for record format + playback.
 */
(function () {
  'use strict';

  var installed = false;

  function installLongTextRecorder() {
    if (installed) return true;
    if (typeof window.productBuilder === 'undefined') return false;
    installed = true;

    var AE = window.pbAudioEngine;
    var WF = window.pbAudioWaveform;
    var instances = new WeakMap();
    var allRecorders = [];

    function scheduleFooterNavSync() {
      if (window.PBFooterNav && typeof window.PBFooterNav.scheduleSync === 'function') {
        window.PBFooterNav.scheduleSync();
      } else if (window.productBuilder && typeof window.productBuilder.checkStepValidity === 'function') {
        window.productBuilder.checkStepValidity();
      }
    }

    function getAudioLabel(textLabel) {
      return String(textLabel || '').trim() + ' (audio)';
    }

    function showMsg(wrap, text, isError, actionsHtml) {
      var el = wrap.querySelector('.pb-lt-message');
      if (!el) return;
      el.textContent = '';
      if (text) el.appendChild(document.createTextNode(text));
      if (actionsHtml) {
        var span = document.createElement('span');
        span.innerHTML = actionsHtml;
        el.appendChild(span);
      }
      el.className = 'pb-lt-message' + (isError ? ' pb-lt-message-error' : '');
      el.style.display = text || actionsHtml ? 'block' : 'none';
    }

    function hideMsg(wrap) {
      showMsg(wrap, '', false, '');
    }

    function setPanel(wrap, name) {
      var idle = wrap.querySelector('.pb-lt-idle');
      var rec = wrap.querySelector('.pb-lt-recording');
      var playback = wrap.querySelector('.pb-lt-playback');
      var ta = wrap.querySelector('textarea');
      if (idle) idle.hidden = name !== 'idle';
      if (rec) rec.hidden = name !== 'recording';
      if (playback) playback.hidden = name !== 'saved';
      if (ta) {
        ta.disabled = name === 'recording';
        wrap.classList.toggle('pb-lt-is-recording', name === 'recording');
      }
    }

    function syncSelections(inst, url, operation) {
      var PB = window.productBuilder;
      var ctx = operation ? operation.context : inst.lifecycle.begin().context;
      if (!ctx || !ctx.selections) return;
      var audioLabel = getAudioLabel(inst.textLabel);
      if (url) ctx.selections[audioLabel] = url;
      else delete ctx.selections[audioLabel];
    }

    function notifyValidity(inst) {
      var ta = inst.textarea;
      if (ta && window.productBuilder.validateText) {
        window.productBuilder.validateText(ta);
      } else if (window.productBuilder.checkStepValidity) {
        window.productBuilder.checkStepValidity();
      }
    }

    function bindUploadFailureActions(wrap, inst) {
      wrap.querySelector('.pb-lt-btn-retry-upload')?.addEventListener('click', function () {
        inst.uploadPending();
      });
      wrap.querySelector('.pb-lt-btn-discard-upload')?.addEventListener('click', function () {
        inst.discardPendingUpload();
      });
    }

    function PbLongTextRecorder(wrap) {
      this.wrap = wrap;
      this.textarea = wrap.querySelector('textarea');
      this.audioInput = wrap.querySelector('.pb-lt-audio-input');
      this.textLabel = wrap.dataset.textLabel || (this.textarea && this.textarea.dataset.label) || '';
      this.maxSec = parseInt(wrap.dataset.recorderMax || '300', 10) || 300;
      this.pendingBlob = null;
      this.pendingPeaks = null;
      this.pendingDuration = 0;
      this.recorder = null;

      var self = this;
      this.lifecycle = AE.createFieldLifecycle(wrap, function () { self.discardActiveSession(); }, function () {
        if (self.player) self.player.destroy();
        instances.delete(wrap);
        var index = allRecorders.indexOf(self);
        if (index !== -1) allRecorders.splice(index, 1);
      });
      var canvas = wrap.querySelector('.pb-lt-playback .pb-lt-wave-playback');
      this.player = AE ? AE.createPlayer({
        canvas: canvas,
        onProgress: function (progress, peaks) {
          if (WF && canvas && peaks) WF.drawBars(canvas, peaks, progress);
        },
        onPlayStateChange: function (playing) {
          self.updatePlayIcon(playing);
        },
        onError: function () {
          showMsg(wrap, 'Could not play this recording. Try recording again.', true);
        }
      }) : null;

      this.bind();
      bindUploadFailureActions(wrap, this);
      allRecorders.push(this);
    }

    PbLongTextRecorder.prototype.bind = function () {
      var self = this;
      var wrap = this.wrap;
      var playBtn = wrap.querySelector('.pb-lt-playback .pb-lt-btn-play');
      if (playBtn && !playBtn.dataset.pbLtBound) {
        playBtn.dataset.pbLtBound = '1';
        if (AE && !playBtn.querySelector('.pb-lt-icon-play')) {
          playBtn.innerHTML = AE.PLAY_BUTTON_HTML;
        }
        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          self.togglePlay();
        });
      }
      if (this.player) {
        this.player.bindSeek(
          wrap.querySelector('.pb-lt-playback .pb-lt-wave-playback'),
          function () {
            return !!(self.audioInput && self.audioInput.value);
          }
        );
      }

      if (this.audioInput && this.audioInput.value) {
        this.showSaved(this.audioInput.value);
      } else {
        setPanel(wrap, 'idle');
      }
    };

    PbLongTextRecorder.prototype.updatePlayIcon = function (playing) {
      var btn = this.wrap.querySelector('.pb-lt-playback .pb-lt-btn-play');
      if (!btn) return;
      var playIcon = btn.querySelector('.pb-lt-icon-play');
      var pauseIcon = btn.querySelector('.pb-lt-icon-pause');
      if (playIcon) playIcon.hidden = !!playing;
      if (pauseIcon) pauseIcon.hidden = !playing;
      btn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    };

    PbLongTextRecorder.prototype.afterBlobReady = function (blob) {
      var operation = this.operation;
      if (!this.lifecycle.current(operation)) return;
      var self = this;
      var wrap = this.wrap;
      this.pendingBlob = blob;
      this.recorder = null;
      setPanel(wrap, 'idle');
      hideMsg(wrap);
      scheduleFooterNavSync();

      var decode = AE ? AE.decodeBlobPeaks(blob) : Promise.resolve({ peaks: [], duration: 0 });
      decode.then(function (result) {
        if (!self.lifecycle.current(operation)) return;
        self.pendingPeaks = result.peaks;
        if (result.duration) self.pendingDuration = result.duration;
        var probe = AE ? AE.probeBlobPlayback(blob) : Promise.resolve(true);
        return probe.then(function (ok) {
          if (!self.lifecycle.current(operation)) return;
          if (!ok) {
            showMsg(wrap, 'This recording cannot be previewed on your device.', true,
              ' <button type="button" class="pb-lt-btn-retry pb-lt-btn-discard-upload">Discard</button>');
            bindUploadFailureActions(wrap, self);
            scheduleFooterNavSync();
            return;
          }
          self.uploadPending();
        });
      }).catch(function () {
        if (!self.lifecycle.current(operation)) return;
        self.uploadPending();
      });
    };

    PbLongTextRecorder.prototype.discardPendingUpload = function () {
      this.lifecycle.invalidate();
      this.pendingBlob = null;
      this.pendingPeaks = null;
      this.pendingDuration = 0;
      hideMsg(this.wrap);
      if (this.audioInput && this.audioInput.value) setPanel(this.wrap, 'saved');
      else setPanel(this.wrap, 'idle');
      notifyValidity(this);
      scheduleFooterNavSync();
    };

    PbLongTextRecorder.prototype.uploadPending = function () {
      var operation = this.operation;
      if (!this.lifecycle.current(operation) || this.uploading === operation) return;
      var self = this;
      var wrap = this.wrap;
      if (!this.pendingBlob) return;

      var uploader = window.pbMediaUpload;
      if (!uploader || typeof uploader.upload !== 'function') {
        showMsg(wrap, 'Upload module not loaded. Please refresh.', true);
        return;
      }

      showMsg(wrap, 'Uploading…', false);
      var audioLabel = getAudioLabel(this.textLabel);
      var blob = AE ? AE.normalizeAudioBlob(this.pendingBlob) : this.pendingBlob;

      this.uploading = operation;
      uploader.upload(blob, { label: audioLabel, kind: 'audio' })
        .then(function (url) {
          if (!self.lifecycle.current(operation)) return;
          self.uploading = null;
          hideMsg(wrap);
          self.pendingBlob = null;
          if (self.audioInput) {
            self.audioInput.value = url;
            self.audioInput.dataset.valid = 'true';
          }
          syncSelections(self, url, operation);
          self.showSaved(url);
          notifyValidity(self);
          try {
            document.dispatchEvent(new CustomEvent('pb-media-saved', { bubbles: true, composed: true, detail: { label: audioLabel, url: url } }));
          } catch (e) {}
        })
        .catch(function (err) {
          if (!self.lifecycle.current(operation)) return;
          self.uploading = null;
          showMsg(
            wrap,
            (err && err.message) ? err.message : 'Upload failed.',
            true,
            ' <button type="button" class="pb-lt-btn-retry pb-lt-btn-retry-upload">Retry</button>' +
            ' <button type="button" class="pb-lt-btn-retry pb-lt-btn-discard-upload">Discard</button>'
          );
          bindUploadFailureActions(wrap, self);
        });
    };

    PbLongTextRecorder.prototype.showSaved = function (url) {
      var operation = this.operation = this.lifecycle.begin();
      var self = this;
      setPanel(this.wrap, 'saved');
      if (this.player) {
        this.player.stop();
        this.player.setRemoteUrl(url, {
          peaks: this.pendingPeaks,
          duration: this.pendingDuration
        });
      }
      this.updatePlayIcon(false);
      if (!WF || !url) return;
      var canvas = this.wrap.querySelector('.pb-lt-playback .pb-lt-wave-playback');
      if (this.pendingPeaks) {
        WF.drawBars(canvas, this.pendingPeaks, 0);
        return;
      }
      fetch(url)
        .then(function (r) { return r.blob(); })
        .then(function (blob) { return AE ? AE.decodeBlobPeaks(blob) : WF.decodePeaks(blob); })
        .then(function (result) {
          if (!self.lifecycle.current(operation)) return;
          self.pendingPeaks = result.peaks;
          if (result.duration) self.pendingDuration = result.duration;
          if (self.player) self.player.setPeaks(result.peaks, result.duration);
          WF.drawBars(canvas, result.peaks, 0);
        })
        .catch(function () {
          if (!self.lifecycle.current(operation)) return;
          WF.drawBars(canvas, new Array(WF.BAR_COUNT).fill(0.12), 0);
        });
    };

    PbLongTextRecorder.prototype.deleteSaved = function () {
      this.lifecycle.invalidate();
      if (this.player) this.player.clear();
      this.pendingBlob = null;
      this.pendingPeaks = null;
      this.pendingDuration = 0;
      if (this.audioInput) {
        this.audioInput.value = '';
        this.audioInput.dataset.valid = 'false';
      }
      syncSelections(this, null);
      hideMsg(this.wrap);
      setPanel(this.wrap, 'idle');
      notifyValidity(this);
      scheduleFooterNavSync();
    };

    PbLongTextRecorder.prototype.togglePlay = function () {
      if (!this.player) return;
      var now = Date.now();
      if (now - (this._lastToggle || 0) < 350) return;
      this._lastToggle = now;
      var url = this.audioInput && this.audioInput.value;
      if (!url) return;
      this.player.toggle();
    };

    PbLongTextRecorder.prototype.startRecording = function () {
      if (this.recorder) return;
      var operation = this.operation = this.lifecycle.begin();
      var self = this;
      var wrap = this.wrap;
      var now = Date.now();
      if (now - (this._lastRecordAttempt || 0) < 400) return;
      this._lastRecordAttempt = now;
      hideMsg(wrap);

      var mediaApi = (window.BUILDER_DATA && window.BUILDER_DATA.mediaApiEndpoint) || '';
      if (!mediaApi || !String(mediaApi).trim()) {
        showMsg(wrap, 'Audio upload is not configured.', true);
        return;
      }
      if (!AE || !AE.createRecorder) {
        showMsg(wrap, 'Audio engine not loaded. Please refresh.', true);
        return;
      }

      if (this.player) this.player.stop();
      this.pendingBlob = null;
      this.pendingPeaks = null;
      this.pendingDuration = 0;

      this.recorder = AE.createRecorder({
        maxSec: this.maxSec,
        scopeEl: wrap.closest('.pb-step') || wrap,
        onRecordingStart: function () {
          if (!self.lifecycle.current(operation)) return;
          setPanel(wrap, 'recording');
          scheduleFooterNavSync();
        },
        onTimer: function (elapsed) {
          if (!self.lifecycle.current(operation)) return;
          if (elapsed >= self.maxSec && self.recorder) self.recorder.stop();
        },
        onLiveFrame: function (scroller) {
          if (!self.lifecycle.current(operation)) return;
          var canvas = wrap.querySelector('.pb-lt-recording .pb-lt-wave-canvas');
          if (canvas) scroller.draw(canvas);
        },
        onBlob: function (blob) {
          if (!self.lifecycle.current(operation)) return;
          self.afterBlobReady(blob);
        },
        onEmpty: function () {
          self.recorder = null;
          if (!self.lifecycle.current(operation)) return;
          showMsg(wrap, 'No audio captured. Try again.', true);
          if (self.audioInput && self.audioInput.value) setPanel(wrap, 'saved');
          else setPanel(wrap, 'idle');
          notifyValidity(self);
          scheduleFooterNavSync();
        },
        onCancel: function () {
          self.recorder = null;
          if (!self.lifecycle.current(operation)) return;
          hideMsg(wrap);
          if (self.audioInput && self.audioInput.value) setPanel(wrap, 'saved');
          else setPanel(wrap, 'idle');
          scheduleFooterNavSync();
        }
      });

      this.recorder.start().catch(function () {
        if (!self.lifecycle.current(operation)) return;
        showMsg(wrap, 'Microphone access needed to record.', true);
        self.recorder = null;
        scheduleFooterNavSync();
        var msg = wrap.querySelector('.pb-lt-message');
        if (msg && !wrap.querySelector('.pb-lt-btn-retry-mic')) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pb-lt-btn-retry pb-lt-btn-retry-mic';
          btn.textContent = 'Try again';
          msg.appendChild(document.createTextNode(' '));
          msg.appendChild(btn);
          btn.addEventListener('click', function () { self.startRecording(); });
        }
      });
    };

    PbLongTextRecorder.prototype.discardActiveSession = function () {
      if (this.player) this.player.stop();
      this.lifecycle.invalidate();
      if (this.recorder) {
        this.recorder.cancel();
        this.recorder = null;
      }
      this.discardPendingUpload();
    };

    PbLongTextRecorder.prototype.cancelRecording = function () {
      this.discardActiveSession();
    };

    PbLongTextRecorder.prototype.finishRecording = function () {
      if (this.recorder) this.recorder.stop();
    };

    function migrateLongtextWrap(wrap) {
      if (!wrap || wrap.dataset.pbLtMigrated === '1') return;
      var box = wrap.querySelector('.pb-longtext-box');
      if (!box) return;
      var innerMeta = box.querySelector('.pb-input-meta');
      if (innerMeta) innerMeta.remove();
      ['.pb-lt-recording', '.pb-lt-playback'].forEach(function (sel) {
        var el = box.querySelector(sel);
        if (!el) return;
        var meta = wrap.querySelector(':scope > .pb-input-meta');
        var anchor = meta || box;
        if (el.parentElement === box) anchor.insertAdjacentElement('afterend', el);
      });
      var stopBtn = wrap.querySelector('.pb-lt-btn-stop');
      var cancelBtn = wrap.querySelector('.pb-lt-btn-cancel');
      if (stopBtn && cancelBtn && (cancelBtn.compareDocumentPosition(stopBtn) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        var strip = stopBtn.closest('.pb-lt-rec-strip');
        if (strip) strip.insertBefore(stopBtn, cancelBtn);
      }
      if (stopBtn && !stopBtn.querySelector('.pb-lt-rec-dot')) {
        stopBtn.innerHTML =
          '<span class="pb-lt-rec-dot" aria-hidden="true"></span>' +
          '<span class="pb-lt-btn-stop-label">Stop</span>';
      } else if (stopBtn) {
        stopBtn.querySelectorAll('.pb-lt-icon-stop').forEach(function (el) { el.remove(); });
      }
      wrap.querySelectorAll('.pb-lt-btn-play .pb-lt-icon-play, .pb-lt-btn-play .pb-lt-icon-pause').forEach(function (svg) {
        svg.setAttribute('width', '22');
        svg.setAttribute('height', '22');
      });
      wrap.dataset.pbLtMigrated = '1';
    }

    function initWrap(wrap) {
      if (!wrap || instances.has(wrap)) return instances.get(wrap);
      migrateLongtextWrap(wrap);
      var inst = new PbLongTextRecorder(wrap);
      instances.set(wrap, inst);
      return inst;
    }

    function wrapFromDelegatedTarget(el, selector) {
      if (!el || !el.closest) return null;
      var hit = el.closest(selector);
      if (!hit) return null;
      return hit.closest('.pb-longtext-wrap');
    }

    function installDelegatedHandlers() {
      if (installDelegatedHandlers.done) return;
      installDelegatedHandlers.done = true;

      document.addEventListener('click', function (e) {
        var wrap = wrapFromDelegatedTarget(e.target, '.pb-lt-btn-mic');
        if (wrap) {
          e.preventDefault();
          initWrap(wrap)?.startRecording();
          return;
        }
        wrap = wrapFromDelegatedTarget(e.target, '.pb-lt-recording .pb-lt-btn-cancel');
        if (wrap) {
          e.preventDefault();
          initWrap(wrap)?.cancelRecording();
          return;
        }
        wrap = wrapFromDelegatedTarget(e.target, '.pb-lt-recording .pb-lt-btn-stop');
        if (wrap) {
          e.preventDefault();
          initWrap(wrap)?.finishRecording();
          return;
        }
        wrap = wrapFromDelegatedTarget(e.target, '.pb-lt-btn-delete');
        if (wrap) {
          e.preventDefault();
          initWrap(wrap)?.deleteSaved();
          return;
        }
        wrap = wrapFromDelegatedTarget(e.target, '.pb-lt-btn-retry-mic');
        if (wrap) {
          e.preventDefault();
          initWrap(wrap)?.startRecording();
        }
      }, true);
    }

    function bootRecorderRoots() {
      window.pbLongTextRecorder?.init('#main-flow-container');
      window.pbLongTextRecorder?.init('#sub-flow-container');
    }

    function hydrateWrap(wrap, audioUrl) {
      var inst = initWrap(wrap);
      if (!inst || !inst.audioInput) return;
      inst.audioInput.value = audioUrl || '';
      inst.audioInput.dataset.valid = audioUrl ? 'true' : 'false';
      if (audioUrl) {
        syncSelections(inst, audioUrl);
        inst.pendingPeaks = null;
        inst.pendingDuration = 0;
        inst.showSaved(audioUrl);
      } else {
        inst.deleteSaved();
      }
      notifyValidity(inst);
    }

    function cancelAllActiveRecordings() {
      var live = allRecorders.slice();
      for (var i = 0; i < live.length; i++) {
        var inst = live[i];
        if (inst.wrap.isConnected === false) { inst.lifecycle.dispose(); continue; }
        if (inst && typeof inst.discardActiveSession === 'function') inst.discardActiveSession();
      }
    }

    window.pbLongTextRecorder = {
      init: function (root) {
        var scope = typeof root === 'string' ? document.querySelector(root) : (root || document);
        if (!scope) return;
        AE.disposeFieldScope();
        scope.querySelectorAll('.pb-longtext-wrap').forEach(initWrap);
      },
      hydrate: hydrateWrap,
      getAudioLabel: getAudioLabel,
      cancelAllActiveRecordings: cancelAllActiveRecordings,
    };

    installDelegatedHandlers();
    document.addEventListener('builder:ready', bootRecorderRoots);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootRecorderRoots);
    } else {
      setTimeout(bootRecorderRoots, 0);
    }

    return true;
  }

  if (!installLongTextRecorder()) {
    document.addEventListener('DOMContentLoaded', installLongTextRecorder);
    document.addEventListener('builder:ready', installLongTextRecorder);
  }
})();
